module.exports = __webpack_public_path__ + "img/LBA-Statistik_Kennzahlen.4451e1cc.svg";